export default {"src":"/_next/static/media/send-money.0481f423.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};